export default __webpack_public_path__ + "static/media/cameraI.30167273.jpg";